import Swiper from 'swiper';
import 'swiper/css';
import { Navigation, Pagination } from 'swiper/modules';

const helpers = window.BASE_HELPERS || {};
const { Mobile } = helpers;

const MODULE = document.querySelectorAll('[data-module="cards_3_colunas"]');

class Cards3Colunas {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    init() {
        this.components.forEach(component => {
            const swiperComponent = component.querySelector('.swiper');
            if (swiperComponent) this.initSwiper(swiperComponent);
        });
    }

    initSwiper(swiperComponent) {
        new Swiper(swiperComponent, {
            modules: [Pagination, Navigation],
            loop: true,
            slidesPerView: 1,
            spaceBetween: 24,
            breakpoints: {
                1024: {
                    loop: false,
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                }
            },
            navigation: {
                nextEl: swiperComponent.querySelector('.swiper-button-next'),
                prevEl: swiperComponent.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: swiperComponent.querySelector('.swiper-pagination'),
                clickable: true,
                type: 'bullets',
            },
            on: {
                afterInit: (swiper) => {
                    if (Mobile.isMobile() && swiper.slides.length > 1) {
                        swiper.el.querySelector('.pagination').classList.add('active');
                    }

                    if (!Mobile.isMobile() && swiper.slides.length > 3) {
                        swiper.el.querySelector('.pagination').classList.add('active');
                    }
                }
            },
        });
    }
}

(() => {
    if (MODULE) {
        new Cards3Colunas();
    }
})();

export default Cards3Colunas;
